import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge only knows Tailwind's default scales. Without these, a custom
 * type step like `text-body` is read as a colour and silently drops
 * `text-muted-foreground`, and `rounded-pill` / `shadow-brand-sm` never
 * replace the defaults they override. Keep in sync with `@theme` in styles.css.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        'display',
        'headline',
        'title-lg',
        'title',
        'title-sm',
        'subtitle',
        'body-lg',
        'body',
        'body-sm',
        'caption',
        'eyebrow',
        'eyebrow-sm'
      ],
      radius: ['pill', 'nav'],
      shadow: ['brand', 'brand-sm', 'modal'],
      ease: ['standard', 'emphasized']
    }
  }
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
